var NKTEN_DISABLE_ANIMATIONS = true;

document.addEventListener('DOMContentLoaded', initCommunityNkten);
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initCommunityNkten);
}

function initCommunityNkten(event) {
  const root = event && event.target && event.target.querySelector
    ? event.target.querySelector('[data-community-nkten]')
    : document.querySelector('[data-community-nkten]');

  const sections = root ? [root] : document.querySelectorAll('[data-community-nkten]');

  sections.forEach((section) => {
    if (!section || section.dataset.communityInitialized) return;
    section.dataset.communityInitialized = 'true';

    const tiles = section.querySelectorAll('[data-community-tile]');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (NKTEN_DISABLE_ANIMATIONS || prefersReducedMotion || !window.gsap || !window.ScrollTrigger) {
      tiles.forEach((t) => { t.style.opacity = '1'; t.style.transform = 'none'; });
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    gsap.set(tiles, { opacity: 0, scale: 0.92 });

    gsap.to(tiles, {
      opacity: 1,
      scale: 1,
      duration: 0.6,
      ease: 'expo.out',
      stagger: 0.08,
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        once: true,
      },
    });
  });
}
